import { BRAND_PRIMARY } from '../theme';

export default function Logo({ size = 22 }: { size?: number }) {
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: size,
        height: size,
        borderRadius: 7,
        background: `linear-gradient(135deg, ${BRAND_PRIMARY} 0%, #00D49B 100%)`,
        boxShadow: '0 1px 2px rgba(0, 185, 107, 0.35)',
        color: '#fff',
        fontWeight: 700,
        fontSize: size <= 18 ? 11 : 13,
        letterSpacing: -0.4,
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "PingFang SC", "Segoe UI", Roboto, sans-serif',
      }}
      aria-label="AlphaStep"
    >
      A
    </span>
  );
}
